import { render, staticRenderFns } from "./payments-link.vue?vue&type=template&id=20632c41&"
import script from "./payments-link.vue?vue&type=script&lang=js&"
export * from "./payments-link.vue?vue&type=script&lang=js&"
import style0 from "./payments-link.vue?vue&type=style&index=0&id=20632c41&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports